import SeoSetupComponent from '../Components/Seo/SeoSetupComponent';

function SeoSetupPage() {
  return <SeoSetupComponent />;
}

export default SeoSetupPage;
